// extracted by mini-css-extract-plugin
export var box = "_7d-1";
export var checkboxRow = "_7d-8";
export var checked = "_7d-2";
export var descriptionSpacer = "_7d-a";
export var disabled = "_7d-3";
export var icon = "_7d-6";
export var input = "_7d-0";
export var labelSpacer = "_7d-9";
export var medium = "_7d-5";
export var small = "_7d-4";
export var text = "_7d-7";